import { PARTITION_KEY, SORT_KEY } from 'root/src/shared/constants/apiDynamoIndexes'
import { userIdKey } from 'root/src/shared/constants/keys'

export const pkProp = item => item?.[PARTITION_KEY]
export const skProp = item => item?.[SORT_KEY]
export const skSeparator = '|'
export const userIdProp = item => item?.[userIdKey]
export const dynamoItemsProp = queryResponse => queryResponse?.Items
